import {
  Avatar,
  Box,
  Popper,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { User } from "../../../../../../types/types";
import { formatMediaUrl } from "../../../../../../utils/formatters/formatMedia";

interface UsersMentionListProps {
  showMentions: boolean;
  isSearchLoading: boolean;
  contentRef: React.RefObject<HTMLDivElement>;
  users: User[];
  handleUserSelect: (user: User) => void;
}

const UsersMentionList = ({
  showMentions,
  isSearchLoading,
  contentRef,
  users,
  handleUserSelect,
}: UsersMentionListProps) => {
  const { t } = useTranslation("common");

  return (
    <Popper
      open={showMentions && !isSearchLoading}
      anchorEl={contentRef.current}
      placement="bottom-start"
      style={{ zIndex: 1300 }}
    >
      <Paper elevation={3} style={{ maxHeight: 300, overflowY: "auto", width: "300px" }}>
        {isSearchLoading ? (
          <Box sx={{ padding: 2, textAlign: "center" }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <List>
            {users.map((user) => {
              return (
                <ListItem
                  key={user.id}
                  component="div"
                  onClick={() => handleUserSelect(user)}
                  sx={{ cursor: "pointer" }}
                >
                  <ListItemAvatar>
                    <Avatar src={formatMediaUrl(user?.media?.url || user?.entity?.mediaUrl || "")} alt={user.firstName}>
                      {`${user.firstName?.slice(0, 1).toUpperCase()}${user.lastName?.slice(0, 1).toUpperCase()}`}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${user.firstName} ${user.lastName}`}
                    secondary={
                      user.role ? t(`user.role.${user.role}`) : user.subRole ? t(`user.role.${user.subRole}`) : null
                    }
                  />
                </ListItem>
              );
            })}
          </List>
        )}
      </Paper>
    </Popper>
  );
};

export default UsersMentionList;
